function PlayerVideo(){

    let that = this;

    if( $('.player-youtube').length > 0 ){
        loadScript.load( 'https://www.youtube.com/iframe_api', this.initPlayerYoutube );
    }

    if( $('.player-vimeo').length > 0 ){
        loadScript.load( 'https://player.vimeo.com/api/player.js', this.initPlayerVimeo );
    }
}

PlayerVideo.prototype.initPlayerYoutube = function(){

    let that = this;

    $('.player-youtube').each(function(index){

        var el = $(this);
        var videoID = $(this).attr('data-video-id');
        var poster = "https://img.youtube.com/vi/"+ videoID +"/maxresdefault.jpg";
        var player = el.closest('.block-video__iframe');

        player.append('<img src="'+poster+'">');

        el.prev('.block-video__overlay').on('click', function(){
            if ( ! player.hasClass('playing') ) {
                new YT.Player(videoID, {
                    height: '360',
                    width: '640',
                    videoId: videoID,
                    playerVars: {
                        'autoplay': 1,
                        'showinfo': 0,
                        'modestbranding': 1,
                        'rel': 0,
                        'enablejsapi': 1
                    }
                });
                player.addClass('playing');
            }
        });

    });

};

PlayerVideo.prototype.initPlayerVimeo = function(){

    $('.player-vimeo').each(function(index){

        var el = $(this);
        var videoID = $(this).attr('data-video-id');
        var url = $(this).attr('data-video-url');
        var player = el.closest('.block-video__iframe');

        $.ajax({
            type:'GET',
            url: 'https://vimeo.com/api/oembed.json?url=' + encodeURIComponent(url),
            dataType: 'json',
            success: function(data) {
                var poster = data.thumbnail_url;
                player.append('<img src="'+poster+'">');
            }
        });

        var playerVimeo = new Vimeo.Player(videoID, { id : videoID });

        el.prev('.block-video__overlay').on('click', function(){
            if ( ! player.hasClass('playing') ) {
                playerVimeo.play();
                player.addClass('playing');
            }
        });

    });

};